import { useCfarStyles, useModuleBEM } from "@b2bportal/core-themes";
import { CoreFlightsCfarExerciseComponents } from "@b2bportal/core-types";
import { LoadingScreen } from "../../../../components/Slots/LoadingScreen";

import defaultStyles from "./AirCfarExerciseLoadingScreen.module.scss";

export const AirCfarExerciseLoadingScreen = (props: {
  title: string;
  subtitle?: string;
}) => {
  const [block, cn] = useModuleBEM(
    useCfarStyles(
      CoreFlightsCfarExerciseComponents.AirCfarExerciseLoadingScreen,
      defaultStyles
    ),
    CoreFlightsCfarExerciseComponents.AirCfarExerciseLoadingScreen
  );

  const { title } = props;

  return (
    <div className={block}>
      <LoadingScreen
        className={cn("loading-popup")}
        loading
        averageLoadingTime={20}
        loadingSteps={[
          {
            title,
          },
        ]}
      />
    </div>
  );
};
